<template>
    <div class="tab-mission-wrap section-space--mt_80">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="tab-mission-image">
                    <img src="../assets/img/banners/aeroland-tab-content-image-06.png" alt="" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="tab-content-inner">
                    <div class="ht-service-box--three mb-40">
                        <div class="service-box-wrap text-left">
                            <div class="image__media">
                                <img src="../assets/img/icons/aeroland-tab-content-image-icon-01.png" class="img-fluid" alt="aeroland-payment-box-icon-01">
                            </div>
                            <div class="content">
                                <h6 class="sub-heading mb-10 text-uppercase">{{$t('danismahatti')}}</h6>
                                <h4 class="heading"><a href="tel:+905322412008">0532 241 20 08</a></h4>
                                <div class="service_text">7/24 {{$t('telefondestegi')}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="ht-service-box--three mb-40">
                        <div class="service-box-wrap">
                            <div class="image__media">
                                <img src="../assets/img/icons/aeroland-tab-content-image-icon-02.png" class="img-fluid" alt="aeroland-payment-box-icon-01">
                            </div>
                            <div class="content">
                                <h6 class="sub-heading mb-10 text-uppercase">{{$t('gorusbildirin')}}</h6>
                                <h6 class="heading"><a href="mailto:info@barkodyazilimevi.com.tr">info@barkodyazilimevi.com.tr</a></h6>
                                <div class="service_text">7/24 {{$t('maildestegi')}}</div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="ht-service-box--three mb-40">
                        <div class="service-box-wrap">
                            <div class="image__media">
                                <img src="../assets/img/icons/aeroland-app-showcase-box-icon-image-03.png" class="img-fluid" alt="aeroland-payment-box-icon-01">
                            </div>
                            <div class="content">
                                <h6 class="sub-heading mb-10 text-uppercase">{{$t('faturabilgileri')}}</h6>
                                <h6 class="heading">Barkod Yazılımevi San. ve Tic Ltd. Şti</h6>
                                <span class="heading">Perpa Ticaret Merkezi B Blok Kat:9 No:1454</span>
                                <p class="heading">Okmeydanı/Şişli/İstanbul</p>
                                <p class="heading">Şişli VD 1420592791</p>
                                <div class="service_text">{{$t('efaturamukellefi')}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="ht-service-box--three mb-40">
                        <div class="service-box-wrap text-left">
                            <div class="image__media">
                                <img src="../assets/img/icons/aeroland-startup-box-icon-02.png" class="img-fluid" alt="aeroland-payment-box-icon-01">
                            </div>
                            <div class="content">
                                <h6 class="sub-heading mb-10 text-uppercase">{{$t('sosyalmedya')}}</h6>
                                <ul class="list ht-social-networks solid-rounded-icon">
                                    <li class="item">
                                    <a href="https://www.facebook.com/barkodyazilim" target="_blank" class="social-link"> <i class="fab fa-facebook social-link-icon"></i> </a>facebook
                                    </li>
                                    <li class="item">
                                    <a href="https://www.twitter.com/barkodyazilim" target="_blank" class="social-link"> <i class="fab fa-twitter social-link-icon"></i> </a>twitter
                                    </li>
                                    <li class="item">
                                    <a href="https://www.instagram.com/barkodyazilim" target="_blank" class="social-link"> <i class="fab fa-instagram social-link-icon"></i> </a>instagram
                                    </li>
                                </ul>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TabContentThree'
    };
</script>

